import commonExtend from '../common/extend';
import Extend from 'flarum/common/extenders';
import RankingsPage from './components/RankingsPage';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';
import User from 'flarum/common/models/User';
import LeaderboardEntry from '../common/models/LeaderboardEntry';
export default [...commonExtend, new Extend.Routes() //
.add('rankings', '/rankings', RankingsPage), new Extend.Store() //
.add('leaderboard-entries', LeaderboardEntry), new Extend.Model(Discussion) //
.attribute('votes').attribute('hasUpvoted').attribute('hasDownvoted').attribute('canVote').attribute('seeVotes'), new Extend.Model(Post) //
.hasMany('upvotes').hasMany('downvotes').attribute('votes').attribute('canVote').attribute('canSeeVotes').attribute('hasUpvoted').attribute('hasDownvoted').attribute('seeVoters'), new Extend.Model(User) //
.attribute('points').hasMany('ranks').attribute('canHaveVotingNotifications')];